export const queryKeys = {
  EYEABLE_RULES: 'EyeAbleRules',
  EYEABLE_RULES_META: 'EyeAbleRulesMeta',
  AI_RULES: 'aiRules',
  AI_RULES_META: 'aiRulesMeta',
  WCAG_RULES: 'WCAGRules',
  WCAG_RULES_META: 'WCAGRulesMeta',
  PDF_ERROR_TEXT: 'pdfErrorText',
  FOUND_URLS: 'foundUrls',
  PDFS: 'pdfs',
  USER_PDFS: 'userPdfs',
  IMPROVED_PDFS: 'improvedPdfs',
  REPORT: 'report',
  HISTORY: 'history',
  PAGE_DETAIL_REPORT: 'pageDetailReport',
  SIGNUP: 'signup',
  FOUND_URLS_HISTORY: 'foundUrlsHistory',
  NOTIFICATIONS: 'notifications',
  LIGHTHOUSE: 'lighthouse',
  URL_MAP: 'urlMap',
  LIGHTHOUSE_SUMMARY: 'lighthouseSummary',
  SPELL_CHECKING: 'spellChecking',
  SPELL_CHECKING_READABILITY_SCORE: 'spellCheckingReadabilityScore',
  SPELL_CHECKING_HISTORY: 'spellCheckingHistory',
  UPDATE_USER: 'updateUser',
  GENERATOR_FILES: 'generatorFiles',
  ADMIN_SEARCH: 'adminSearch',
  HELP_SEARCH: 'helpSearch',
  FONTS: 'fonts',
  ORG_FILES_CONTENTS: 'orgFilesContents',
  REPORT_SETTINGS: 'reportSettings',
  GUIDED_TESTING_FILES: 'guidedTestingFiles',
  GUIDED_TESTING_TESTS_OVERVIEW: 'guidedTestingTestsOverview',
  RULE_MARKDOWN: 'ruleMarkdown',
  MARKDOWN: 'markdown',
  ACC_STATES_TEXT: 'accStatesText',
  ACC_OTHER_TEXT: 'accOtherText',
  MANUAL_TESTS: 'manualTests',
  MANUAL_TESTING_SCHEMA: 'manualTestingSchema',
  MANUAL_TEST_DOCS: 'manualTestDocs',
  ACCESS_STORAGE: 'accessStorage',
};

export const demoEntry = {
  id: 451,
  domain: 'audit.zugang4all.de',
  cdnDirectory: 'audit.zugang4all.de',
  conformanceTarget: 'AAA + Best Practice',
  complianceTarget: 'AAA + Best Practice',
};

export const demoUser = {
  id: 1083,
  apiKey: '4bYhW6401da3bnP5',
  aiCreditLimit: 100000,
  aiCreditUsage: 0,
  role: 'customer',
  surname: 'DEMO',
  name: 'MODE',
  company: 'Demo Mode Company',
  email: 'info@eye-able.com',
  phone: '+49 176 64103397',
  primaryOrganisation: 1327,
  isInfinite: true,
  fullName: 'DEMO MODE',
  firstName: 'DEMO',
  lastName: 'MODE',
  hasPassword: true,
  tokenExpires: 4099852799, // 2099 in unix timestamp
  isAdmin: false,
  isSalesAdmin: false,
  isOrgAdmin: false,
  orgAdmin: false,
};

export const demoModeConfig = {
  creationDate: '2023-04-21T11:08:44.853Z',
  enableQueryParameters: true,
  targetLang: '',
  urlsToCheck: [],
  regex: ['.*blockedUrls'],
  actions: [
    {
      regexToMatch: ['.*login'],
      timing: 'afterAudit',
      steps: [
        {
          type: 'input',
          target: '#username',
          text: 'test@eye-able.com',
        },
        {
          type: 'input',
          text: 'mySecretPassword',
          target: '#password',
        },
        {
          type: 'click',
          target: "button[type='submit']",
        },
        {
          type: 'delay',
          delay: '3000',
        },
      ],
    },
  ],
  dictionary: {
    1: ['Eye-Able'],
  },
};

// base endpoints
export const storageUrl = 'https://assets.eye-able.com/';
export const reportStorageUrl = 'https://report-storage.eye-able.com/';
export const accessStorageUrl = 'https://access.eye-able.com/';

export const manualTestDocs = {
  basePath: 'manual-testing-assets/docs',
  fallbackLanguage: 'EN',
};
if (import.meta.env.VITE_USE_DEV_API) console.log('Using dev API');

// for production the CDN will redirect to the correct API server
// use origin to make it work with the dev and live servers
export const apiUrl = import.meta.env.PROD
  ? window.location.origin + '/api/'
  : import.meta.env.VITE_USE_LOCAL_API === 'true'
    ? 'http://localhost:3000/'
    : import.meta.env.VITE_USE_DEV_API === 'true'
      ? 'https://apiv3-dev.eye-able.com/'
      : 'https://apiv3.eye-able.com/';

// 'http://127.0.0.1:3000/'

export const userPdfStorageUrl =
  import.meta.env.VITE_USE_LOCAL_API_PDF === 'true'
    ? 'http://127.0.0.1:3000/'
    : import.meta.env.VITE_USE_DEV_API_PDF === 'true'
      ? 'https://pdfauditapihqxkcsio-pdf-audit-api-dev.functions.fnc.fr-par.scw.cloud/'
      : 'https://pdfcheck.eye-able.com/';

// cdn translateScript adress
export const cdnTranslateScript =
  'https://translate-cdn.eye-able.com/eye-able-translate.js';
//dev
//export const cdnTranslateScript = 'https://eye-able-translate-dev.b-cdn.net/eye-able-translate.js';

// api endpoints
export const api = {};

api.i18n = apiUrl + 'i18n';
api.i18nDomain = api.i18n + '/domain';
api.i18nTranslate = api.i18n + '/translate';
api.i18nRelease = api.i18n + '/release';
api.i18nReleaseLock = api.i18n + '/release/lock';
api.i18nReleaseUnlock = api.i18n + '/release/unlock';
api.organisations = apiUrl + 'organisations';
api.guestOrganisations = apiUrl + 'guestOrganisations';
api.adminOrganisationLimits = api.organisations + '/adminLimits';
api.adminAiOrganisationOptions = api.organisations + '/adminAiOptions';
api.hubspotCompanies = apiUrl + 'hubspot/companies';
api.settings = api.organisations + '/settings';
api.orgFiles = api.organisations + '/files';
api.orgUsers = api.organisations + '/users';
api.orgGuests = api.organisations + '/guests';
api.orgLicenses = api.organisations + '/licenses';
api.organisationEntitlementCatalog =
  api.organisations + '/entitlements/catalog';
api.orgIps = api.organisations + '/ipAddress';
api.scimToken = api.organisations + '/scimToken';
api.usersettings = api.organisations + '/usersettings';
api.orgSettings = api.organisations + '/settings';
api.logs = apiUrl + 'loggs';
api.securityLogs = api.logs + '/security';
api.policies = apiUrl + 'policies';
api.policyDomainAccess = api.policies + '/domainAccess';
api.governanceIssues = apiUrl + 'governanceIssues';
api.governanceIssuesExport = api.governanceIssues + '/export';
api.governanceIssuePolicies = apiUrl + 'governanceIssues/policies';
api.governanceOverview = apiUrl + 'governanceOverview';
api.reportEntries = apiUrl + 'reportEntries';
api.crawlerStatus = apiUrl + 'crawler/status';
api.auditEntriesLookup = apiUrl + 'auditEntries/lookup';
api.auditEntryPins = apiUrl + 'auditEntryPins';
api.reportEntriesSettings = api.reportEntries + '/settings';
api.reportEntryConfig = api.reportEntries + '/config';
api.reportEntryRescan = api.reportEntries + '/rescan';
api.listAllLicenses = apiUrl + 'listAllLicenses';
api.users = apiUrl + 'users';
api.multipleUsers = api.users + '/multiple';
api.userEffectiveRights = api.users + '/effectiveRights';
api.myEffectiveRights = api.users + '/me/effectiveRights';
api.licenseConstraints = apiUrl + 'licenseConstraints';
api.login = apiUrl + 'authentication/login';
api.oidcConfig = apiUrl + 'authentication/oidcConfig';
api.samlLogin = apiUrl + 'authentication/samlLogin';
api.loginAsCustomer = apiUrl + 'authentication/loginAsCustomer';
api.signup = apiUrl + 'authentication/signup';
api.changePwd = apiUrl + 'authentication/changePw';
api.whoami = apiUrl + 'authentication/whoami';
api.pwLost = apiUrl + 'authentication/pwLost';
api.logout = apiUrl + 'authentication/logout';
api.conformanceTarget = apiUrl + 'conformanceTarget';
api.conformanceTargetLegislation = api.conformanceTarget + '/legislation';
api.todo = apiUrl + 'todo';
api.todos = apiUrl + 'todos';
api.supportMail = apiUrl + 'supportMail';
api.offerRequest = apiUrl + 'offerRequest';
api.auditLicenses = apiUrl + 'auditLicenses';
api.assistLicenses = apiUrl + 'assistLicenses';
api.assistConfig = apiUrl + 'assistConfig';
api.auditEntriesDomainAlias = apiUrl + 'auditEntries/domainAlias';
api.assistTestLicense = api.assistLicenses + '/testLicense';
api.searchBase = apiUrl + 'search/';
api.searchAllLicenses = api.searchBase + 'allLicenses/';
api.jobs = apiUrl + 'jobs/';
api.jobsSimpleLangDocument = api.jobs + 'simpleLangDocument';
api.plainLanguage = apiUrl + 'simpleLanguage';
api.plainLanguageDocument = api.plainLanguage + '/document';
api.plainLanguageStream = api.plainLanguage + '/stream';
api.accessibilityStatement = apiUrl + 'accessibilityStatement';
api.access = apiUrl + 'access';
api.accessSuggestions = api.access + '/suggestions';
api.accessSuggestionsReset = api.accessSuggestions + '/reset';
api.accessSettings = api.access + '/settings';
api.accessSetup = api.access + '/setup';
api.accessScript = api.access + '/script';
api.ally = apiUrl + 'ally';
api.teams = apiUrl + 'teams';
api.teamDetails = api.teams + '/details';
api.teamMembers = api.teams + '/members';
api.teamRights = api.teams + '/rights';
api.teamEffectiveMembers = api.teams + '/effectiveMembers';
api.accessLicenses = apiUrl + 'accessLicenses';
api.translateClients = apiUrl + 'translateClients';
api.translateClientsAll = api.translateClients + '/all';
api.jiraConfig = apiUrl + 'jira/config';
api.jiraApiBase = apiUrl + 'jira/api';
api.jiraProjects = api.jiraApiBase + '/projects';
api.jiraProject = api.jiraApiBase + '/project';
api.jiraIssue = api.jiraApiBase + '/issue';
api.jiraIssues = api.jiraApiBase + '/issues';
api.jiraUsers = api.jiraApiBase + '/users';
api.jiraUsersFind = api.jiraUsers + '/find';
api.jiraUsersProjectAssignable = api.jiraUsers + '/project';
api.jiraIssueMetaData = api.jiraIssue + '/metadata';
api.jiraIssueComment = api.jiraIssue + '/comment';
api.jiraIssueTransition = api.jiraIssue + '/transition';
api.jiraIssueTypes = api.jiraProject + '/issuetypes';
api.jiraComponents = api.jiraProject + '/components';
api.translationsDomain = apiUrl + 'manageTranslation/domain';
api.translationsSubpage = apiUrl + 'manageTranslation/subpage';
api.translationsTranslation = apiUrl + 'manageTranslation/translation';
api.translationsManual = api.translationsTranslation + '/allManual';
api.translationSearch = api.translationsTranslation + '/search';
api.translationSingleReference =
  api.translationsTranslation + '/singleReference';
api.transDomainSearch = api.translationsDomain + '/search';
api.transDomainStats = api.translationsDomain + '/stats';
api.transDomainLangPairs = api.translationsDomain + '/langPairs';
api.transDomainAllTranslation = api.translationsTranslation + '/allTranslation';
api.transSubpageListAll = api.translationsSubpage + '/allSubpages';
api.transSubpageAllTranslation = api.translationsSubpage + '/allTranslation';
api.transSubpageSearch = api.translationsSubpage + '/search';
api.transSubpageStats = api.translationsSubpage + '/stats';
api.createPdf = apiUrl + 'createPdf';
api.manualTest = apiUrl + 'manualTest';
api.reportEntryFiles = api.reportEntries + '/files';
api.reportExportAvailableDates = apiUrl + 'reportExport/availableDates';
api.transcription = apiUrl + 'transcription';
api.translate_plain_apiUrl = apiUrl;
api.guidedTest = apiUrl + 'guidedTest';
api.guidedTestAll = api.guidedTest + '/all';
api.manualTest = apiUrl + 'manualTest';
api.manualTestAll = api.manualTest + '/all';
api.manualTestBulk = api.manualTest + '/bulk';
api.manualTestPublish = api.manualTest + '/publish';
api.manualTestScope = api.manualTest + '/scope';
api.manualTestExport = api.manualTest + '/export';
api.manualTestRasterize = api.manualTest + '/rasterize';
api.manualTestSchema = api.manualTest + '/schema';
api.manualTestComment = api.manualTest + '/comments';
api.manualTestCommentResolveAll = api.manualTestComment + '/resolveAll';
api.helpCenter = apiUrl + 'helpCenter';
api.helpCenterSearch = api.helpCenter + '/search';
api.listAllPartnerFiles = apiUrl + 'listPartnerFiles';
api.supportThreads = apiUrl + 'supportThreads';
api.supportThreadsAdmin = api.supportThreads + '/admin';
api.supportThreadMessages = api.supportThreads + '/messages';
api.supportThreadStatus = api.supportThreads + '/status';
api.reportExportJob = apiUrl + 'reportExportJob';
api.reportExportBatchJob = apiUrl + 'reportExportBatchJob';
api.reportSubscription = apiUrl + 'reportSubscription';
api.ignore = apiUrl + 'ignore';
api.ignoreIssues = api.ignore + '/issue';
// Eye-Able AI tests (Phase 2 dashboard area)
api.aiTests = apiUrl + 'aiTests';
api.aiTestsOverview = api.aiTests + '/overview';
api.aiTestsFindings = api.aiTests + '/findings';
api.aiTestsActivity = api.aiTests + '/activity';
api.aiTestsPages = api.aiTests + '/pages';
api.aiTestsDiscoveredPages = api.aiTests + '/discoveredPages';
api.aiTestsPagesFrequency = api.aiTestsPages + '/frequency';
api.aiTestsUnlockDemo = api.aiTests + '/unlockDemo';
api.aiTestsRequestDemo = api.aiTests + '/requestDemo';
api.partnerContingents = apiUrl + 'partnerContingents';
api.partnerContingentsAll = api.partnerContingents + '/all';
api.partnerManagement = apiUrl + 'partnerManagement';
api.partnerManagementOrganisations = api.partnerManagement + '/organisations';
api.partnerManagementUsers = api.partnerManagement + '/users';
api.partnerManagementLicense = api.partnerManagement + '/license';
api.sectorBenchmarks = apiUrl + 'sectorBenchmarks';
api.glossary = apiUrl + 'manageTranslation/glossary';
api.glossaryDictionary = api.glossary + '/dictionary';
api.glossaryAvailableLangs = api.glossary + '/availableLangs';
api.glossaryCostPreview = api.glossary + '/costPreview';
